function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { Attention, CheckOne, CloseOne, CloseSmall, Info, Loading } from '../../common/icons';
var IconMap = {
  info: Info,
  error: CloseOne,
  warning: Attention,
  success: CheckOne,
  loading: Loading
};
export function Message(props) {
  var type = props.type,
      className = props.className,
      shadow = props.shadow,
      content = props.content,
      icon = props.icon,
      _props$showIcon = props.showIcon,
      showIcon = _props$showIcon === void 0 ? true : _props$showIcon,
      hasClose = props.hasClose,
      onClose = props.onClose,
      extra = _objectWithoutProperties(props, ["type", "className", "shadow", "content", "icon", "showIcon", "hasClose", "onClose"]);

  var contentCls = usePrefixCls('message-content');
  var closeCls = usePrefixCls('message-close');
  var iconCls = usePrefixCls('message-icon');
  var iconNode = null;

  if (showIcon) {
    if (icon) {
      iconNode = React.createElement("span", {
        className: iconCls
      }, icon);
    } else if (type && IconMap[type]) {
      var Comp = IconMap[type];
      iconNode = React.createElement("span", {
        className: iconCls
      }, React.createElement(Comp, {
        theme: "filled"
      }));
    } else {
      iconNode = null;
    }
  }

  var closeNode = hasClose ? React.createElement(CloseSmall, {
    className: closeCls,
    onClick: onClose
  }) : null;
  var contentNode = content ? React.createElement("span", {
    className: contentCls
  }, content) : null;
  var cls = classnames(usePrefixCls('message', {
    type: type,
    shadow: shadow,
    'no-icon': !iconNode,
    'has-close': !!closeNode
  }), className);
  return React.createElement("span", Object.assign({}, extra, {
    className: cls
  }), iconNode, closeNode, contentNode);
}